import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BackupdrPricingSheetComponent } from '../../components/backupdr-pricing-sheet/backupdr-pricing-sheet';
import { CloudPricingSheetComponent } from '../../components/cloud-pricing-sheet/cloud-pricing-sheet';
import { CoverScreenComponent } from '../../components/cover-screen/cover-screen';
import { CyberPricingSheetComponent } from '../../components/cyber-pricing-sheet/cyber-pricing-sheet';
import { HardwareSoftwareSheetComponent } from '../../components/hardware-software-sheet/hardware-software-sheet';
import { MspPricingSheetComponent } from '../../components/msp-pricing-sheet/msp-pricing-sheet';
import { ProjectComponent } from '../../components/project/project';
import { MsaPage } from '../../pages/msa/msa';
import { PricelistMasterPage } from '../../pages/pricelist-master/pricelist-master';
import { SowListPage } from '../../pages/sow-list/sow-list';
import { SowPage } from '../../pages/sow/sow';
import { DataServiceProvider } from '../data-service/data-service';
@Injectable()
export class ComponentServiceProvider {
  dataArray: any = [];
  tabTemplates: any = [{
    'id': 'ProposalViewer',
    'templates': [{
      "id": "0",
      "templateName": '1',
      "selectIcon": "",
      "sheetName": "TITLE",
      "name": 'Title',
      "componentName": `<div class="PageContainer" style="min-height: 350mm;border: 50px solid #ccc;"><div style="min-height: 90mm;padding: 5%;display: flex;
        justify-content: center;
        align-items: center;">
        <img style="width: 25%;
        display: block;
        margin: 0 auto;" id="starportTitleLogo" alt="starport logo">
      </div>
      <div style="width: 100%;min-height: 90mm;">
      <div style="border: 42px solid;height: 50mm;
      display: flex;
    align-items: center;
    justify-content: center;width: 50%; float:left;">
      <img style="width: 20%;
        display: block;
        margin: 0 auto;" id="companyLogo" alt="starport logo">
      </div>
      <div style="background-color: #ccc;height: 50mm;
      padding: 9%;display: grid;
      align-items: center;
      justify-content: center; width: 50%;float:right;">
      <ion-label style=" font-size: 16px !important;font-weight: 500;text-align: center;">Statement of Work - No.  <span id="TitlePageSowNo"></span></ion-label>
      <ion-label style=" font-size: 12px !important;text-align: center;white-space: normal;"><span id="ProposalName"></span></ion-label>
      </div>
    </div>
    <div style="width: 100%;">
      <ion-label  style=" font-size: 16px !important;font-weight: 500;text-align: center;">SOW Effective Date : <span id="companyDate"></span>
      </ion-label>
    </div>
    </div>
    `,
    }, {
      "id": "1",
      "templateName": '2',
      "name": 'MSP Pricing Sheet',
      "selectIcon": "",
      "sheetName": "MSP",
      "componentName": `<div class="pricingsheet_container">
        <table>
          <thead>
            <tr>
              <th colspan="12" class="text-center" style="background-color: #000;color: #fff;padding: 5px;">MANAGED IT SERVICES<span id="mspClientName"><span></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th colspan="4" class="text-center"
                style="font-weight: 500;padding:5px;border-left: 1px solid #000;border-bottom: 1px solid #000;background-color: #f2f2f2;color: #000;">
                No. of Users: <span id="NoOfUsers"></span></th>
              <th colspan="4" class="text-center"
                style="font-weight: 500;padding:5px;border-bottom: 1px solid #000;background-color: #f2f2f2;color: #000;">
                No. of Devices(PCs/Servers): <span id="NoOfDevices"></span></th>
              <th colspan="4" class="text-center"
                style="font-weight: 500;padding:5px;border-bottom: 1px solid #000;border-right: 1px solid #000;background-color: #f2f2f2;color: #000;">
                No. of Locations: <span id="noOfLocations"></span></th>
            </tr>
          </tbody>
        </table>
        <table style="margin-top: 5px;"  id="mspManagedService1">
          <thead>
            <tr>
              <th colspan="12" class="text-left" style="background-color: #808080;color: #fff;padding: 5px;">ONE TIME Start-up Fees</th>
            </tr>
            <tr>
              <th colspan="12" class="text-left"
                style="border-bottom: 1px solid #808080;border-right: 1px solid #808080;font-weight: 700;padding:3px 7px;border-left: 1px solid #808080;background-color: #d9d9d9;color: #000;">
                Managed Services - Start Up Fees</th></tr>
                <tr>
                 <th style="padding: 0px;">
                 <div id="startUpDescribe" class="text-left" style="padding: 3px 7px;
                 overflow-x: hidden;border-right: 1px solid #808080;font-size: 14px;color: #305496;font-weight:400;
                 overflow-y: auto; border-left: 1px solid #808080;min-height: 24px;"></div>
                </th> 
                </tr>
            </thead>
        </table>
        <table id="mspManagedService2">
          <thead>
            <tr>
                <th style="width: 85%;padding: 3px;border-left: 1px solid #808080;"></th>
                <th id="startUpFees" class="text-right" style="width: 15%;padding: 5px;font-weight:400;font-size: 12px;color: #305496;border-left: 1px solid #808080;border-top: 1px solid #808080;border-right: 1px solid #808080;"><br /></th>
            </tr>
            <tr id="MSPShowStartupDiscount">
              <th class="text-left" style="width: 85%;padding: 5px 0px 5px 35px;font-weight:400;font-size: 12px;color: #305496;border-left: 1px solid #808080;border-bottom: 1px solid #808080;">Courtesy Discount</th>
              <th id="startUpCD" class="text-right" style="width: 15%;padding: 5px;font-size: 12px;border: 1px solid #808080;color: red;"><br /></th>
          </tr>
          <tr>
            <th class="text-left"
              style="width: 85%;border-bottom: 1px solid #808080;font-weight: 700;padding:3px 7px;border-left: 1px solid #808080;background-color: #d9d9d9;color: #000;">
             Subtotal - Managed Services - Start Up Fees</th>
              <th class="text-right"  id="startUpSubtotal"
              style="width: 15%;border-bottom: 1px solid #808080;border-right: 1px solid #808080;font-weight: 700;padding:3px;border-left: 1px solid #808080;background-color: #d9d9d9;color: #000;">
              <br /></th></tr>
          </thead>
          <tbody>
            <tr>
              <th colspan="12" style="padding: 3px;border-right: 1px solid #808080;border-bottom: 1px solid #808080; border-left: 1px solid #808080;">
              </th>
            </tr>
          </tbody>
        </table>
        <table  id="mspbackupDr1">
          <thead>
            <tr>
              <th colspan="12" class="text-left"
                style="border-bottom: 1px solid #808080;border-right: 1px solid #808080;font-weight: 700;padding:3px 7px;border-left: 1px solid #808080;background-color: #d9d9d9;color: #000;">
              Backup DR One Time Fees</th></tr>
                <tr>
                 <th style="padding: 0px;">
                 <div  id="backUpDrDescribe"  class="text-left" style="padding: 3px 7px;
                 overflow-x: hidden;border-right: 1px solid #808080;color: #305496;font-size: 14px;font-weight:400;
                 overflow-y: auto; border-left: 1px solid #808080;min-height: 30px;"></div>
                </th> 
                </tr>
            </thead>
        </table>
        <table  id="mspbackupDr2">
          <thead>
            <tr>
                <th style="width: 85%;padding: 5px;border-left: 1px solid #808080;"></th>
                <th id="backUpDrOneTime" class="text-right" style="width: 15%;font-weight:400;padding: 5px;font-size: 12px;color: #305496;border-left: 1px solid #808080;border-top: 1px solid #808080;border-right: 1px solid #808080;"><br /></th>
            </tr>
            <tr id="mspBackupDrDiscount">
              <th class="text-left" style="width: 85%;padding: 5px 0px 5px 35px;font-size: 12px;font-weight:400;color: #305496;border-left: 1px solid #808080;border-bottom: 1px solid #808080;">Courtesy Discount of <span id="backUpDrCD"></span></th>
              <th id="backUpDrCDVal" class="text-right" style="width: 15%;padding: 5px;font-size: 12px;border: 1px solid #808080;color: red;"><br /></th>
          </tr>
          <tr>
            <th class="text-left"
              style="width: 85%;border-bottom: 1px solid #808080;font-weight: 700;padding:3px 7px;border-left: 1px solid #808080;background-color: #d9d9d9;color: #000;">
             Subtotal - Backup DR One Time Fees</th>
              <th id="backUpDrSubtotal" class="text-right"
              style="width: 15%;border-bottom: 1px solid #808080;border-right: 1px solid #808080;font-weight: 700;padding:3px;border-left: 1px solid #808080;background-color: #d9d9d9;color: #000;">
              <br /></th></tr>
          </thead>
          <tbody>
            <tr>
              <th colspan="12" style="padding: 3px;border-right: 1px solid #808080;border-bottom: 1px solid #808080; border-left: 1px solid #808080;">
              </th>
            </tr>
          </tbody>
        </table>
        <table id="mspMisc1">
          <thead>
            <tr>
              <th colspan="12" class="text-left"
                style="border-bottom: 1px solid #808080;border-right: 1px solid #808080;font-weight: 700;padding:3px 7px;border-left: 1px solid #808080;background-color: #d9d9d9;color: #000;">
               Misc. One-Time Fees - e.g. HW, SW, Lic, etc.</th></tr>
                <tr>
                 <th style="padding: 0px;">
                 <div id="miscOneTimeDescribe" class="text-left" style="padding: 3px 7px;
                 overflow-x: hidden;border-right: 1px solid #808080;color: #305496;font-size: 14px;font-weight:400;
                 overflow-y: auto; border-left: 1px solid #808080;min-height: 30px;"></div>
                </th> 
                </tr>
            </thead>
        </table>
          <table  id="mspMisc2">
          <thead id="mspMisc3">
            <tr>
                <th style="width: 85%;padding: 5px;border-left: 1px solid #808080;"></th>
                <th id="miscOneTimeVal" class="text-right" style="width: 15%;padding: 5px;font-weight:400;color: #305496;font-size: 12px;border-left: 1px solid #808080;border-top: 1px solid #808080;border-right: 1px solid #808080;"><br></th>
            </tr>
          <tr>
            <th class="text-left"
              style="width: 85%;border-bottom: 1px solid #808080;font-weight: 700;padding:3px 7px;border-left: 1px solid #808080;background-color: #d9d9d9;color: #000;">
             Subtotal - Misc. One-Time Fees - e.g. HW, SW, Lic, etc.</th>
              <th id="miscOneTimeSubtotal" class="text-right"
              style="width: 15%;border-bottom: 1px solid #808080;border-right: 1px solid #808080;font-weight: 700;padding:3px;background-color: #d9d9d9;color: #000;">
              <br/> </th></tr>
          </thead>
          <tbody>
          <tr>
          <th class="text-left" style="padding:3px;width: 85%;background-color: #808080;color: #fff;">TOTAL - ONE TIME Start-up Fees</th>
          <th id="TotalOneTimeStartupFees" class="text-right" style="padding:3px;width: 15%;background-color: #808080;color: #fff;"><br/></th>
          </tr>
          </tbody>
        </table>
        <table id="MSPMonthly1" style="margin-top: 5px;">
          <thead>
            <tr>
              <th colspan="12" style="text-align: left;background-color: #000;padding: 6px;color: #fff;">MONTHLY Fees</th>
            </tr>
            <tr>
              <th colspan="12" class="text-left"  id="mspMonthlyManageIt1"
                style="border-bottom: 1px solid #000;border-right: 1px solid #000;font-weight: 700;padding:3px 7px;border-left: 1px solid #000;background-color: #d9d9d9;color: #000;">
                Managed IT Services</th></tr>
                <tr>
                 <th style="padding: 0px;">
                 <div id="MonthlyFeesDescribe" class="text-left" style="padding: 5px 15px;
                 overflow-x: hidden;border-right: 1px solid #000;font-weight:400;font-size: 14px;color: #305496;
                 overflow-y: auto; border-left: 1px solid #000;min-height: 30px;"></div>
                </th> 
                </tr>
          </thead>
        </table>
        <table id="mspMonthlyManageIt2">
          <tbody>
            <tr>
              <th style="width: 75%;padding: 0px 5px;font-weight:400;color: #305496;font-size: 12px; border-left: 1px solid #000;border-top: 1px solid #000;"></th>
              <th style="width: 10%;padding: 0px 5px; font-weight:400;color: #305496;font-size: 12px;border-top: 1px solid #000;">Hours</th>
              <th style="text-align:right;width: 15%;font-weight:400;padding: 0px 5px;font-size: 12px; color: #305496;border-top: 1px solid #000; border-right: 1px solid #000;">Total</th>
            </tr>
            <tr>
              <th style="width: 75%;padding: 5px;font-weight:400;color: #305496;font-size: 12px;border-right: 1px solid #000;border-left: 1px solid #000;border-top: 1px solid #000;text-align: left;">Server Support Remote/Connectivity - Combination of Remote & On-Site</th>
              <th id="remoteConnectingHour" style="font-weight:400;width: 10%;padding: 5px;font-size: 12px; color: #305496;border-right: 1px solid #000;border-top: 1px solid #000;"></th>
              <th id="remoteConnectingTotal" style="font-weight:400;text-align:right;width: 15%;padding: 5px;font-size: 12px; color: #305496;border-right: 1px solid #000;border-top: 1px solid #000;"></th>
            </tr>
            <tr id="mspMonthlyManageEnd">
              <th style="width: 75%;padding: 5px;font-weight:400;color: #305496;font-size: 12px;border-right: 1px solid #000;border-left: 1px solid #000;border-top: 1px solid #000;text-align: left;">End User/Desktop Managed Services - Combination of Remote & On-Site</th>
              <th  id="endUserDesktopHour" style="font-weight:400;width: 10%;padding: 5px;font-size: 12px; color: #305496;border-right: 1px solid #000;border-top: 1px solid #000;"></th>
              <th  id="EndUserOneTime" style="font-weight:400;text-align:right;width: 15%;padding: 5px;font-size: 12px; color: #305496;border-right: 1px solid #000;border-top: 1px solid #000;"></th>
            </tr>
          </tbody>
        </table>
      <table id="mspMonthlyManageIt3">
        <tbody>
          <tr>
            <th class="text-left"
              style="width: 85%;border-bottom: 1px solid #000;border-top: 1px solid #000;font-weight: 700;padding:3px 7px;border-left: 1px solid #000;background-color: #d9d9d9;color: #000;">
             Subtotal - Managed IT Services</th>
              <th id="subtotalManagedItService" class="text-right"
              style="text-align:right;width: 15%;border-bottom: 1px solid #000;border-top: 1px solid #000;font-weight: 700;padding:3px;border-right: 1px solid #000;background-color: #d9d9d9;color: #000;">
             </th></tr>
        </tbody>
      </table>
      <table id="mspMiscFee1">
        <tbody>
          <tr>
            <th colspan="12" style="padding: 3px;border-right: 1px solid #808080;border-bottom: 1px solid #808080; border-left: 1px solid #808080;">
            </th>
          </tr>
          <tr>
            <th colspan="12" class="text-left"
          style="border: 1px solid #000;font-weight: 700;padding:3px 7px;background-color: #d9d9d9;color: #000;">
          Misc. Fees - e.g.  HW, SW, Lic, etc.</th></tr>
        </tbody>
      </table>
      <table id="mspMiscFee2">
        <thead>
          <tr>
            <th style="width: 85%;padding: 0px;">
              <div id="miscFeeDescribe" class="text-left" style="padding: 3px 7px;
              overflow-x: hidden;border-right: 1px solid #808080;color: #305496;font-size: 14px;font-weight:400;
              overflow-y: auto; border-left: 1px solid #808080;min-height: 24px;"></div>
             </th> 
             <th id="miscFeeVal" style="width: 15%; padding: 5px;text-align: right;font-size: 12px;border-right: 1px solid #808080;">
            </th>
          </tr>
          <tr>
            <th style="text-align: left;width: 85%;padding: 0px 5px;font-weight:400;color: #305496;font-size: 12px;font-weight:400;border-top: 1px solid #000;border-right: 1px solid #000;border-left: 1px solid #000;">
              <span id="standBtOfficeSpaceReq">Standby Office Space <span id="mspStandByOfficeVal"></span>/mo + ($500/day flat rate, plus time/materials if required)</span>
             </th> 
             <th id="standBtOfficeSpace" style="font-size: 12px;width: 15%;text-align: right; padding: 0px 5px;border-top: 1px solid #000;border-right: 1px solid #000;">
           </th>
          </tr>
          <tr>
            <th
              style="text-align:left;width: 85%;border-bottom: 1px solid #000;border-top: 1px solid #000;font-weight: 700;padding:3px 7px;border-left: 1px solid #000;background-color: #d9d9d9;color: #000;">
             Subtotal -  Misc. Fees - e.g.  HW, SW, Lic, etc.</th>
              <th id="miscFeeSubtotal"
              style="text-align:right;width: 15%;border-bottom: 1px solid #000;border-top: 1px solid #000;font-weight: 700;padding:3px;border-right: 1px solid #000;background-color: #d9d9d9;color: #000;">
             </th></tr>
        </thead>
      </table>
      <table  id="MSPMonthly2">
        <thead>
          <tr>
            <th colspan="12" style="padding: 3px;border-right: 1px solid #808080;border-bottom: 1px solid #000; border-left: 1px solid #808080;">
            </th>
          </tr>
        </thead>
      </table>
      <table id="mspItAddCyberBackup1">
        <thead>
          <tr>
            <th
              style="text-align:left;width: 65%;border-bottom: 1px solid #000;border-top: 1px solid #000;font-weight: 700;padding:3px 7px;border-left: 1px solid #000;background-color: #d9d9d9;color: #000;">
             IT Management, Additional, Cyber, Backup Tools</th>
              <th
              style="text-align:left;font-size:11px;width: 35%;border-bottom: 1px solid #000;border-top: 1px solid #000;font-weight: 400;padding:3px;border-right: 1px solid #000;background-color: #d9d9d9;color: #000;">
             <i>Based on <span id="noOfUsers"></span> user(s) and <span id="noOfDevices"></span> device(s)</i></th></tr>
        </thead>
      </table>
      <table id="mspItAddCyberBackup2">
        <tbody>
          <tr id="mspItManagement">
            <th style="width: 85%;padding: 0px;">
              <div id="itManagementLists" class="text-left" style="padding: 3px 7px;
              overflow-x: hidden;border-right: 1px solid #000;color: #305496;font-size: 12px;font-weight:400;
              overflow-y: auto; border-left: 1px solid #000;min-height: 24px;"></div>
             </th> 
            <th id="itManagementVal" class="text-right" style="width: 15%;font-size: 12px;padding: 5px;font-weight:400;color: #305496;border-right: 1px solid #000;"></th>
        </tr>
        <tr  id="mspAdditional">
          <th style="width: 85%;padding: 0px;">
            <div  id="additionalLists" class="text-left" style="padding: 3px 7px;
            overflow-x: hidden;border-right: 1px solid #000;color: #305496;font-size: 12px;font-weight:400;
            overflow-y: auto; border-left: 1px solid #000;min-height: 24px;border-top: 1px solid #000;"></div>
           </th> 
          <th id="additionalVal" class="text-right" style="font-weight:400;font-size: 12px;width: 15%;padding: 5px;font-size: 12px;color: #305496;border-top: 1px solid #000;border-right: 1px solid #000;"></th>
      </tr>
      <tr id="mspCyber">
        <th style="width: 85%;padding: 0px;">
          <div  id="cyberLists"  class="text-left" style="padding: 3px 7px;border-top: 1px solid #000;
          overflow-x: hidden;border-right: 1px solid #000;color: #305496;font-size: 12px;font-weight:400;
          overflow-y: auto; border-left: 1px solid #000;min-height: 24px;"></div>
         </th> 
        <th  id="cyberVal"  class="text-right" style="width: 15%;padding: 5px;font-weight:400;color: #305496;font-size: 12px;border-top: 1px solid #000;border-right: 1px solid #000;"></th>
      </tr>
      <tr id="mspBackupTools">
        <th style="width: 85%;padding: 0px;">
          <div id="backupToolsLists" class="text-left" style="padding: 5px 7px;border-top: 1px solid #000;
          overflow-x: hidden;border-right: 1px solid #000;color: #305496;font-weight:400;
          overflow-y: auto; border-left: 1px solid #000;min-height: 24px;font-size: 12px;"></div>
         </th> 
        <th id="backupToolsVal"  class="text-right" style="width: 15%;padding: 5px;color: #305496;font-size: 12px;font-weight:400;border-top: 1px solid #000;border-right: 1px solid #000;"></th>
      </tr>
      <tr>
        <th
          style="text-align:left;width: 85%;border-bottom: 1px solid #000;border-top: 1px solid #000;font-weight: 700;padding:3px 7px;border-left: 1px solid #000;background-color: #d9d9d9;color: #000;">
         Subtotal - IT Management, Additional, Cyber, Backup Tools</th>
          <th id="SubtotalTools"
          style="text-align:right;width: 15%;border-left: 1px solid #000;border-bottom: 1px solid #000;border-top: 1px solid #000;font-weight: 700;padding:3px;border-right: 1px solid #000;background-color: #d9d9d9;color: #000;">
         </th></tr>
        </tbody>
      </table>
      <table id="MSPMonthly3">
        <thead>
          <tr>
            <th colspan="12" style="padding: 0px;">
              <div class="text-left" style="padding: 3px 7px;border-top: 1px solid #000;
              overflow-x: hidden;border-right: 1px solid #000;color: #404040;
              overflow-y: auto; border-left: 1px solid #000;min-height: 24px;background-color: #f2f2f2;"><i>NOTE: Tool fees listed above are subject to change due to      a) Vendor pricing changes      b)  exchange rate fluctions
                 c)  No. of Users / Devices in use at <span id="MspNoteClientName"></span>. Each additional user : <span id="MspAdditionalUser"></span> Each additional device : <span id="MspAdditionalDevice"></span> 
              </i></div>
             </th> 
          </tr>
        </thead>
      </table>
      <table  id="MSPMonthly4">
        <thead>
          <tr>
            <th style="width: 85%;text-align:left;background-color: #000;padding: 3px;color: #fff;">MANAGED IT SERVICES<span id="mspMonthlyClientName"><span></th>
          <th id="TotalMonthlyFees" style="width: 15%;text-align:right;padding: 3px;background-color: #000;color: #fff;"></th>
          </tr>
        </thead>
      </table>
      <table id="MspMonthlySect" style="margin-top: 4px;">
        <tr>
          <th id="DiscountMonth" class="text-left" style="width: 85%;padding: 3px 10px;border-top: 1px solid #000;font-weight:400;font-size: 12px;color: #305496;border-left: 1px solid #000;border-bottom: 1px solid #000;"></th>
          <th id="discountPerMonth" class="text-right" style="width: 15%;padding: 3px;border-top: 1px solid #000;border-right: 1px solid #000;border-bottom: 1px solid #000;color: red;"></th>
      </tr>
      </table>
      <table style="margin-top: 4px;">
        <tbody>
          <tr>
            <th style="width: 65%;padding: 3px;text-align: left;background-color: #000;color: #fff;font-weight: 500;">
              </th>
            <th style="width: 20%;padding: 3px;text-align: right;background-color: #000;color: #fff;">One Time</th>
            <th id="mspOneTime" style="width: 15%;padding: 3px;text-align: right;background-color: #000;color: #fff;"></th>
          </tr>
          <tr>
            <th style="width: 65%;padding: 3px;text-align: left;background-color: #000;color: #fff;font-weight: 500;">
              </th>
            <th style="width: 20%;padding: 3px;text-align: right;background-color: #000;color: #fff;">Monthly</th>
            <th id="mspMonthly" style="width: 15%;padding: 3px;text-align: right;background-color: #000;color: #fff;"></th>
          </tr>
        </tbody>
      </table>
      <table id="showMspDiscount">
      <tbody>
      <tr>
      <th colspan="12" style="font-weight: 400;font-size: 12px;padding: 3px 10px;text-align: left;background-color: #000;color: #fff;">
       <i>Includes <span id="IncDiscountMonth"></span></i> </th>
    </tr>
      </tbody>
      </table>
        </div>
      `,
    }, {
      "id": "2",
      "templateName": '3',
      "name": 'CYBER Pricing Sheet',
      "selectIcon": "",
      "sheetName": "CYB",
      "componentName": `<div class="pricingsheet_container" >
        <table>
          <thead>
            <tr>
              <th colspan="12" class="text-center" style="background-color: #000;color: #fff;">CYBER724 SERVICES<span id="cyberClientName"><span></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th colspan="4" class="text-center"
                style="font-weight: 500;padding:5px;border-left: 1px solid #000;border-bottom: 1px solid #000;background-color: #f2f2f2;color: #000;">
                No. of Users: <span id="CyberNoOfUsers"></span></th>
              <th colspan="4" class="text-center"
                style="font-weight: 500;padding:5px;border-bottom: 1px solid #000;background-color: #f2f2f2;color: #000;">
                No. of Devices(PCs/Servers): <span id="CyberNoOfDevices"></span></th>
              <th colspan="4" class="text-center"
                style="font-weight: 500;padding:5px;border-bottom: 1px solid #000;border-right: 1px solid #000;background-color: #f2f2f2;color: #000;">
                No. of Locations: <span id="CyberNoOfLocations"></span></th>
            </tr>
          </tbody>
        </table>
        <table style="margin-top: 5px;"  id="cyberStartup1">
          <thead>
            <tr>
              <th colspan="12" class="text-left" style="background-color: #808080;color: #fff;padding: 5px;">ONE TIME Start-up Fees</th>
            </tr>
            <tr>
              <th style="padding: 0px;">
              <div  id="cyberDescribe"  class="text-left" style="padding: 3px 7px;
              overflow-x: hidden;border-right: 1px solid #808080;color: #305496;font-size: 14px;font-weight:400;
              overflow-y: auto; border-left: 1px solid #808080;min-height: 30px;"></div>
             </th> 
             </tr>
            </thead>
        </table>
        <table id="cyberStartup2">
          <thead>
            <tr>
              <th style="width: 85%;padding: 5px;border-left: 1px solid #808080;"></th>
              <th id="CyberSubtotalOneTime" style="text-align: right;width: 15%;font-weight:400;padding: 5px;font-size: 12px;color: #305496;border-left: 1px solid #808080;border-top: 1px solid #808080;border-right: 1px solid #808080;"><br /></th>
          </tr>
            <tr id="cyberStartup2Discount">
                <th style="width: 85%;padding: 5px;border-left: 1px solid #808080;color: #305496;text-align: left;font-size: 12px;"> Courtesy Discount</th>
                <th id="CyberCourtesyDiscount" style="text-align: right;width: 15%;font-weight:400;padding: 5px;font-size: 12px;color: red;border-left: 1px solid #808080;border-top: 1px solid #808080;border-right: 1px solid #808080;"><br /></th>
            </tr>
          </thead>
          <tbody>
            <tr>
            <th class="text-left" style="padding:5px;width: 85%;background-color: #808080;color: #fff;">TOTAL - ONE TIME Start-up Fees</th>
            <th id="CyberTotalOneTimeStartupFees" style="text-align: right;padding:5px;width: 15%;background-color: #808080;color: #fff;"><br/></th>
            </tr>
            </tbody>
        </table>
        <table style="margin-top: 15px;" id="CyberMonthly1">
          <thead>
            <tr>
              <th colspan="12" style="padding: 5px;text-align: left;background-color: #000;color: #fff;">MONTHLY - Managed Security -  Monitoring and Tool Fees</th>
            </tr>
            </thead>
            </table>
              <table id="CyberCToolTable">
              <tbody>
                <tr>
                  <th style="width: 85%;padding: 0px;">
                    <div id="CyberCToolDescribe" class="text-left" style="font-size: 14px;padding: 5px 15px;
                    overflow-x: hidden;border-right: 1px solid #000;color: #305496;font-weight:400;
                    overflow-y: auto; border-left: 1px solid #000;border-bottom: 1px solid #000;min-height: 75px;"></div>
                   </th> 
                  <th id="CyberCToolServiceValue" class="text-right" style="font-size: 12px;width: 15%;padding: 5px;font-weight:400;color: #305496;border-bottom: 1px solid #000;border-right: 1px solid #000;"></th>
              </tr>
              </tbody>
              </table>
              <table id="CyberAToolTable">
              <tbody>
                <tr>
                  <th style="width: 85%;padding: 0px;">
                    <div id="CyberAdditionalToolDescribe" class="text-left" style="font-size: 14px;padding: 5px 15px;
                    overflow-x: hidden;border-right: 1px solid #000;color: #305496;font-weight:400;
                    overflow-y: auto; border-left: 1px solid #000;min-height: 75px;"></div>
                   </th> 
                  <th id="CyberAToolServiceValue" class="text-right" style="font-size: 12px;width: 15%;padding: 5px;font-weight:400;color: #305496;border-right: 1px solid #000;"></th>
              </tr>
              </tbody>
              </table>
              <table  id="CyberMonthly2">
                <thead>
                  <tr>
                    <th colspan="12" style="padding: 0px;">
                      <div class="text-left" style="font-size: 12px;font-weight:400;padding: 5px 15px;border-top: 1px solid #000;
                      overflow-x: hidden;border-right: 1px solid #000;color: #404040;
                      overflow-y: auto; border-left: 1px solid #000;min-height: 50px;background-color: #f2f2f2;"><i>NOTE: Tool fees listed above are subject to change due to a) Vendor pricing changes _b) exchange rate fluctions
                      c) No. of Users / Devices in use at <span id="cyberNoteClientName"></span> Each additional user : <span id="CyberAdditionalUsers"></span> Each additional device : <span id="CyberAdditionalDevices"></span> </i></div>
                     </th> 
                  </tr>
                </thead>
              </table>
              <table  id="CyberMonthly3">
                <tbody>
                <tr>
                  <th style="font-size: 12px;font-weight:400;padding: 5px;text-align: left;width: 85%;color: #404040;background-color: #f2f2f2;border-top: 1px solid #000;border-left: 1px solid #000;">
                    <i>Incident Response Hourly Fee (If/When needed)</i>
                  </th>
                  <th id="CyberHourly" style="font-size: 12px;padding: 5px;text-align: right;width: 15%;color: #404040;background-color: #f2f2f2;border: 1px solid #000;">
                  </th>
                </tr>
              </tbody>
              </table>
              <table  id="CyberMonthly4">
                <thead>
                  <tr>
                    <th style="padding: 5px;width: 85%;text-align:left;background-color: #000;color: #fff;">TOTAL - MONTHLY - Managed Security -  Monitoring and Tool Fees</th>
                  <th id="CyberMMSMToolFee" style="padding: 5px;width: 15%;text-align:right;background-color: #000;color: #fff;"></th>
                  </tr>
                </thead>
              </table>
              <table id="CyberMonthlySect" style="margin-top: 4px;">
              <tr>
                <th id="CyberDiscountMonthSect" class="text-left" style="width: 85%;padding: 3px 10px;border-top: 1px solid #000;font-weight:400;font-size: 12px;color: #305496;border-left: 1px solid #000;border-bottom: 1px solid #000;"></th>
                <th id="CyberdiscountPerMonth" class="text-right" style="width: 15%;padding: 3px;border-top: 1px solid #000;border-right: 1px solid #000;border-bottom: 1px solid #000;color: red;"></th>
            </tr>
            </table>
              <table style="margin-top: 10px;">
                <tbody>
                  <tr>
                    <th style="width: 65%;padding: 5px;text-align: left;background-color: #000;color: #fff;font-weight: 500;">
                      </th>
                    <th style="width: 20%;padding: 5px;text-align: right;background-color: #000;color: #fff;">One Time</th>
                    <th id="CyberOneTime" style="width: 15%;padding: 5px;text-align: right;background-color: #000;color: #fff;"></th>
                  </tr>
                  <tr>
                    <th style="width: 65%;padding: 5px;text-align: left;background-color: #000;color: #fff;font-weight: 500;">
                      </th>
                    <th style="width: 20%;padding: 5px;text-align: right;background-color: #000;color: #fff;">Monthly</th>
                    <th id="CyberTotalmonthlyFee" style="width: 15%;padding: 5px;text-align: right;background-color: #000;color: #fff;"></th>
                  </tr>
                </tbody>
              </table>
              <table id="cyberShowDisount">
              <tbody>
              <tr>
              <th colspan="12" style="font-weight: 400;font-size: 12px;padding: 5px 10px;text-align: left;background-color: #000;color: #fff;">
               <i>Includes <span id="CyberDiscountMonth"></span></i> </th>
            </tr>
              </tbody>
              </table>
        </div>`,
    }, {
      "id": "3",
      "templateName": '4',
      "name": 'Cloud Pricing Sheet',
      "selectIcon": "",
      "sheetName": "CLD",
      "componentName": `<div class="pricingsheet_container">
        <table>
          <thead>
            <tr>
              <th colspan="12" class="text-center" style="background-color: #000;color: #fff;">CLOUD & HOSTING SERVICES<span id="cloudClientName"><span></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th colspan="12" class="text-center"
                style="font-weight: 500;padding: 0px 5px;border-left: 1px solid #000;border-bottom: 1px solid #000;background-color: #f2f2f2;color: #000;">
                No. of Users: <span id="CloudNoOfUsers"></span></th>
            </tr>
          </tbody>
        </table>
        <table style="margin-top: 5px;" id="cloudStartup1">
          <thead>
            <tr>
              <th colspan="12" class="text-left" style="background-color: #808080;color: #fff;padding: 0px 5px;">ONE TIME Start-up
                Fees</th>
            </tr>
            <tr>
              <th style="padding: 0px;">
                <div id="cloudStartupDescribe" class="text-left" style="padding: 3px 7px;
              overflow-x: hidden;border-right: 1px solid #808080;color: #305496;font-size: 14px;font-weight:400;
              overflow-y: auto; border-left: 1px solid #808080;min-height: 50px;"></div>
              </th>
            </tr>
          </thead>
        </table>
        <table id="cloudStartup2">
          <thead>
            <tr>
              <th style="width: 85%;padding: 0px 5px;border-left: 1px solid #808080;"></th>
              <th id="CloudSubtotalOneTime"
                style="text-align: right;width: 15%;font-weight:400;padding: 0px 5px;font-size: 12px;color: #305496;border-left: 1px solid #808080;border-top: 1px solid #808080;border-right: 1px solid #808080;">
              </th>
            </tr>
            <tr id="cloudCourtesyShow">
              <th
                style="width: 85%;padding: 0px 5px;border-left: 1px solid #808080;color: #305496;text-align: left;font-size: 12px;">
                Courtesy Discount</th>
              <th id="CloudCourtesyDiscount"
                style="text-align: right;width: 15%;font-weight:400;padding: 0px 5px;font-size: 12px;color: red;border-left: 1px solid #808080;border-top: 1px solid #808080;border-right: 1px solid #808080;">
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th class="text-left" style="padding: 0px 5px;width: 85%;background-color: #808080;color: #fff;">TOTAL - ONE TIME
                Start-up Fees</th>
              <th id="CloudTotalOneTimeStartupFees"
                style="text-align: right;padding: 0px 5px;width: 15%;background-color: #808080;color: #fff;"><br /></th>
            </tr>
          </tbody>
        </table>
        <table style="margin-top: 15px;" id="CloudMonthlyTable1">
          <thead>
            <tr>
              <th colspan="12" style="text-align: left;padding: 0px 5px;background-color: #000;color: #fff;">MONTHLY Fees</th>
            </tr>
            <tr id="CloudHosting1">
            <th colspan="12" class="text-left"
              style="border-bottom: 1px solid #000;border-right: 1px solid #000;font-weight: 700;padding: 0px 5px;border-left: 1px solid #000;background-color: #d9d9d9;color: #000;">
              Cloud / Hosting Services</th>
          </tr>
          <tr id="CloudHosting2">
          <th style="padding: 0px;">
            <div id="cloudHostingServiceDescribe" class="text-left" style="padding: 3px 7px;
          overflow-x: hidden;border-right: 1px solid #000;color: #305496;font-size: 14px;font-weight:400;
          overflow-y: auto; border-left: 1px solid #000;min-height: 50px;"></div>
          </th>
        </tr>
          </thead>
        </table>
        <table id="CloudHosting3">
        <thead>
          <tr>
            <th style="width: 85%;padding: 0px 5px;border-left: 1px solid #808080;"></th>
            <th id="CloudMonthlyRecurringHours"
              style="text-align: right;width: 15%;font-weight:400;padding: 0px 5px;font-size: 12px;color: #305496;border-left: 1px solid #808080;border-top: 1px solid #808080;border-right: 1px solid #808080;">
            </th>
          </tr>
          <tr>
          <th class="text-left"
            style="border-top: 1px solid #000;border-left: 1px solid #000;padding: 0px 5px;width: 85%;background-color: #d9d9d9;color: #000;">
            <b>Subtotal - Cloud / Hosting Services</b>
          </th>
          <th class="text-right"
            style="border-bottom: 1px solid #000;border-top: 1px solid #000;border-right: 1px solid #000;padding: 0px 5px;width: 15%;background-color: #d9d9d9;color: #000;">
            <b id="CloudSubtotalHostingServices"></b>
            </th>
        </tr>
        </thead>
        </table>
        <table id="CloudAzureHosting" style="margin-top: 5px">
        <thead>
        <tr>
        <th style="text-align: left;background-color: #d9d9d9;color: #000;border: 1px solid #000;padding: 0px 5px;">
        <b>Azure Hosting</b>
        </th>
        </tr>
        <tr>
        <th style="padding: 0px;">
          <div id="CloudAzureHostingDescribe" class="text-left" style="padding: 3px 7px;
        overflow-x: hidden;border-right: 1px solid #000;color: #305496;font-size: 14px;font-weight:400;
        overflow-y: auto; border-left: 1px solid #000;min-height: 50px;"></div>
        </th>
      </tr>
        </thead>
        </table>
        <table id="CloudAzureHosting1">
        <tbody>
        <tr>
        <th style="width: 85%;padding: 0px 5px;border-left: 1px solid #000;"></th>
        <th id="CloudAzureHostingSubTotal"
          style="text-align: right;width: 15%;font-weight:400;padding: 0px 5px;font-size: 12px;color: #305496;border-top: 1px solid #000;border-left: 1px solid #000;border-right: 1px solid #000;">
        </th>
      </tr>
      <tr>
      <th class="text-left"
        style="border-top: 1px solid #000;border-bottom: 1px solid #000;border-left: 1px solid #000;padding: 0px 5px;width: 85%;background-color: #d9d9d9;color: #000;">
        <b>Subtotal - Azure Hosting</b>
      </th>
      <th class="text-right"
        style="border-bottom: 1px solid #000;border-top: 1px solid #000;border-right: 1px solid #000;padding: 0px 5px;width: 15%;background-color: #d9d9d9;color: #000;">
        <b id="CloudAzureHostingSubTotal1"></b>
        </th>
        </tr>
        <tr>
        <th style="width: 85%;padding: 5px;border-left: 1px solid #000;border-bottom: 1px solid #000;"></th>
        <th style="width: 15%;padding: 5px;color: #305496;border-bottom: 1px solid #000;border-right: 1px solid #000;">
        </th>
      </tr>
      <tr>
        </tbody>
        </table>
        <table id="CloudInfra1">
        <thead>
        <tr>
              <th colspan="12" style="padding: 5px;text-align: left;background-color: #fff;border: 1px solid #000;color: #fff;"></th>
            </tr>
            <tr>
              <th colspan="12" class="text-left"
                style="border-right: 1px solid #000;font-weight: 700;padding:0px 5px;border-left: 1px solid #000;background-color: #d9d9d9;color: #000;">
                Infrastructure as a Service - IaaS</th>
            </tr>
            </thead>
        </table>
        <table id="CloudInfra2">
          <thead>
            <tr>
              <th
                style="width: 30%;font-weight: 700;text-align: left;border: 1px solid #000;background-color: #f2f2f2;padding:0px 5px;">
                QTY : <span id="CloudNoOfServer"></span> Servers
              </th>
              <th
                style="width: 10%;font-weight: 700;text-align: center;border-bottom: 1px solid #000;border-top: 1px solid #000;background-color: #f2f2f2;padding: 0px 5px;">
                [SERVER]
              </th>
              <th
                style="width: 10%;font-weight: 700;text-align: center;border: 1px solid #000;background-color: #f2f2f2;padding: 0px 5px;">
                [CPU]
              </th>
              <th
                style="width: 10%;font-weight: 700;text-align: center;border-bottom: 1px solid #000;border-top: 1px solid #000;background-color: #f2f2f2;padding: 0px 5px;">
                [RAM]
              </th>
              <th
                style="width: 10%;font-weight: 700;text-align: center;border: 1px solid #000;background-color: #f2f2f2;padding: 0px 5px;">
                [DISK]
              </th>
              <th
                style="width: 30%;font-weight: 700;text-align: center;border-top: 1px solid #000;border-right: 1px solid #000;background-color: #fff;padding: 0px 5px;">
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th
                style="width: 30%;font-weight: 500;text-align: left;border: 1px solid #000;background-color: #f2f2f2;padding: 0px 5px;">
                <i>UNIT Pricing
                </i>
              </th>
              <th
                style="width: 10%;color:#808080;font-weight: 500;text-align: right;border-bottom: 1px solid #000;border-top: 1px solid #000;background-color: #f2f2f2;padding: 0px 5px;">
                <i id="serverVal"></i>  </th>
              <th 
                style="width: 10%;color:#808080;font-weight: 500;text-align: right;border: 1px solid #000;background-color: #f2f2f2;padding: 0px 5px;">
                <i id="cpuVal"></i> </th>
              <th
                style="width: 10%;color:#808080;font-weight: 500;text-align: right;border-bottom: 1px solid #000;border-top: 1px solid #000;background-color: #f2f2f2;padding: 0px 5px;">
                <i id="ramVal"></i> </th>
              <th
                style="width: 10%;color:#808080;font-weight: 500;text-align: right;border: 1px solid #000;background-color: #f2f2f2;padding: 0px 5px;">
             <i id="diskVal"></i> </th>
              <th
                style="width: 30%;font-weight: 500;text-align: center;border-top: 1px solid #000;border-right: 1px solid #000;background-color: #fff;padding: 0px 5px;">
              </th>
            </tr>
            <tr>
              <th
                style="width: 30%;font-weight: 500;text-align: right;border: 1px solid #000;background-color: #fff;padding: 0px 5px;">
                <br /> </th>
              <th id="TotalServerVal"
                style="color:#305496;width: 10%;font-weight: 500;text-align: right;border-bottom: 1px solid #000;border-top: 1px solid #000;background-color: #fff;padding: 0px 5px;">
                <br />
              </th>
              <th id="TotalCpuVal"
                style="color:#305496;width: 10%;font-weight: 500;text-align: right;border: 1px solid #000;background-color: #fff;padding: 0px 5px;">
                <br />
              </th>
              <th id="TotalRamVal"
                style="color:#305496;width: 10%;font-weight: 500;text-align: right;border-bottom: 1px solid #000;border-top: 1px solid #000;background-color: #fff;padding: 0px 5px;">
                <br />
              </th>
              <th id="TotalDiskVal"
                style="color:#305496;width: 10%;font-weight: 500;text-align: right;border: 1px solid #000;background-color: #fff;padding: 0px 5px;">
                <br />
              </th>
              <th
                style="width: 30%;font-weight: 500;text-align: center;border-top: 1px solid #000;border-right: 1px solid #000;background-color: #fff;padding: 0px 5px;">
                <br /> </th>
            </tr>
          </tbody>
        </table>
        <table id="CloudInfra3">
          <thead>
            <tr>
              <th class="text-left"
                style="border-bottom: 1px solid #000;border-top: 1px solid #000;border-left: 1px solid #000;padding: 0px 5px;width: 85%;background-color: #d9d9d9;color: #000;">
                <b>Subtotal - Infrastructure as a Service - IaaS</b>
              </th>
              <th class="text-right"
                style="border-right: 1px solid #000;border-bottom: 1px solid #000;border-top: 1px solid #000;padding:0px 5px;width: 15%;background-color: #d9d9d9;color: #000;">
                <b id="CloudSubtotalInfraIaaS"></b></th>
            </tr>
          </thead>
        </table>
        <table id="CloudIaaS1" style="margin-top: 5px;">
          <thead>
            <tr>
              <th colspan="12" class="text-left"
                style="border-bottom: 1px solid #000;border-right: 1px solid #000;font-weight: 700;padding: 0px 5px;border-left: 1px solid #000;background-color: #d9d9d9;color: #000;">
                Software as a Service - IaaS
              </th>
            </tr>
          </thead>
        </table>
        <table id="CloudIaaS2">
          <thead>
            <tr>
              <th style="padding: 0px;">
                <div id="CloudSoftwareIaasDescribe" class="text-left" style="padding: 5px 15px;
                 overflow-x: hidden;border-right: 1px solid #000;color: #305496;font-weight:400;
                 overflow-y: auto; border-left: 1px solid #000;min-height: 75px;"></div>
              </th>
            </tr>
          </thead>
        </table>
        <table id="CloudIaaS3">
          <thead>
            <tr>
              <th class="text-left"
                style="border-bottom: 1px solid #000;font-weight: 700;border-top: 1px solid #000;border-left: 1px solid #000;padding: 0px 5px;width: 85%;background-color: #d9d9d9;color: #000;">
                TOTAL - Software as a Service - IaaS
              </th>
              <th id="CloudSubtotalSoftwareIaaS" class="text-right"
                style="border-bottom: 1px solid #000;font-weight: 700;border-top: 1px solid #000;border-right: 1px solid #000;padding: 0px 5px;width: 15%;background-color: #d9d9d9;color: #000;"><br /></th>
            </tr>
          </thead>
        </table>
        <table id="CloudMiscellaneous1" style="margin-top: 5px;">
          <thead>
            <tr>
              <th colspan="12" class="text-left"
                style="border: 1px solid #000;font-weight: 700;padding:0px 5px;background-color: #d9d9d9;color: #000;">
                Other Products / Services
              </th>
            </tr>
          </thead>
        </table>
        <table  id="CloudMiscellaneous2">
          <thead id="cloudTableToModify">
            <tr id="cloudJSON0">
              <th class="text-left"
                style="border-bottom: 1px solid #000;border-top: 1px solid #000;border-left: 1px solid #000;padding: 0px 5px;width: 85%;background-color: #fff;color: #305496;">
              </th>
              <th class="text-right"
                style="border: 1px solid #000;padding: 0px 5px;width: 15%;background-color: #fff;color: #305496;"></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th class="text-left"
                style="border-bottom: 1px solid #000;border-top: 1px solid #000;border-left: 1px solid #000;padding: 0px 5px;width: 85%;background-color: #d9d9d9;color: #000;">
                Subtotal  - Other Products  / Services								
              </th>
              <th id="CloudSubtotalOtherPS" class="text-right"
                style="border-bottom: 1px solid #000;border-top: 1px solid #000;border-right: 1px solid #000;padding: 0px 5px;width: 15%;background-color: #d9d9d9;color: #000;"><br /></th>
            </tr>
          </tbody>
        </table>
        <table id="CloudMonthlyTable2">
          <thead>
            <tr>
              <th style="padding: 2px 5px;width: 85%;text-align:left;background-color: #000;color: #fff;">
                TOTAL  - MONTHLY Fees</th>
            <th id="CloudTotalMonthlyFees" style="padding: 2px 5px;width: 15%;text-align:right;background-color: #000;color: #fff;"></th>
            </tr>
          </thead>
        </table>
        <table id="CloudMonthlySect" style="margin-top: 4px;">
        <tr>
          <th id="CloudDiscountMonthSect" class="text-left" style="width: 85%;padding: 2px 10px;border-top: 1px solid #000;font-weight:400;color: #305496;border-left: 1px solid #000;border-bottom: 1px solid #000;"></th>
          <th id="ClouddiscountPerMonth" class="text-right" style="width: 15%;padding: 2px 5px;border-top: 1px solid #000;border-right: 1px solid #000;border-bottom: 1px solid #000;color: red;"></th>
      </tr>
      </table>
        <table style="margin-top: 10px;">
          <tbody>
            <tr>
              <th style="width: 65%;padding: 5px;text-align: left;background-color: #000;color: #fff;font-weight: 500;">
               Fee Summary </th>
              <th style="width: 20%;padding: 5px;text-align: right;background-color: #000;color: #fff;">One Time</th>
              <th id="CloudOneTImeFee" style="width: 15%;padding: 5px;text-align: right;background-color: #000;color: #fff;"></th>
            </tr>
            <tr>
              <th style="width: 65%;padding: 5px;text-align: left;background-color: #000;color: #fff;font-weight: 500;">
                </th>
              <th style="width: 20%;padding: 5px;text-align: right;background-color: #000;color: #fff;">Monthly</th>
              <th id="CloudMonthlyFee" style="width: 15%;padding: 5px;text-align: right;background-color: #000;color: #fff;"></th>
            </tr>
          </tbody>
        </table>
        <table id="showCloudDiscount">
          <tbody>
          <tr>
          <th colspan="12" style="font-weight: 400;font-size: 12px;padding: 3px 10px;text-align: left;background-color: #000;color: #fff;">
           <i>Includes <span id="CloudDiscountMonth"></span></i> </th>
        </tr>
          </tbody>
          </table>
      </div>`,
    },
    {
      "id": "4",
      "templateName": '5',
      "name": 'BACKUP/DR Pricing Sheet',
      "selectIcon": "",
      "sheetName": "BKP",
      "componentName": `<div class="pricingsheet_container" style="font-family: 'calibri', 'Helvetica Neue', sans-serif;"">
        <table>
          <thead>
            <tr>
              <th colspan="12" class="text-center" style="background-color: #000;padding:3px;color: #fff;">BACKUP AND DISASTER RECOVERY SERVICES<span id="backupdrClientName"><span></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th colspan="4" class="text-center"
                style="font-weight: 500;padding:3px;border-left: 1px solid #000;border-bottom: 1px solid #000;background-color: #f2f2f2;color: #000;">
                No. of Users: <span id="BackupDrNoOfUsers"></span></th>
              <th colspan="4" class="text-center"
                style="font-weight: 500;padding:3px;border-bottom: 1px solid #000;background-color: #f2f2f2;color: #000;">
                No. of Devices(PCs/Servers): <span id="BackupDrNoOfDevices"></span></th>
              <th colspan="4" class="text-center"
                style="font-weight: 500;padding:3px;border-bottom: 1px solid #000;border-right: 1px solid #000;background-color: #f2f2f2;color: #000;">
                No. of Locations: <span id="BackupDrNoOfLocations"></span></th>
            </tr>
          </tbody>
        </table>
        <table style="margin-top: 15px;" id="BackupdrStarup1">
          <thead>
            <tr>
              <th colspan="12" class="text-left" style="background-color: #808080;padding:3px;color: #fff;"><b>ONE TIME Start-up Fees</b></th>
            </tr>
            </thead>
        </table>
        <table id="BackupdrStarup2">
          <thead>
          <tr>
          <th  id="BackupdrStarup14" style="text-align: left;padding: 0px 5px;border: 1px solid #000;background-color: #f2f2f2;color: #000;">
            <b>Start Up Fees</b>
          </th>
          </tr>
                <tr id="BackupdrStarup11">
                 <th style="padding: 0px;">
                 <div id="backupDrStartupDescribe" class="text-left" style="padding: 5px 15px;
                 overflow-x: hidden;border-right: 1px solid #808080;color: #305496;font-weight:400;
                 overflow-y: auto;border-top: 1px solid #808080; border-left: 1px solid #808080;min-height: 50px;"></div>
                </th> 
                </tr>
            </thead>
        </table>
          <table id="BackupdrStarup3">
          <thead>
            <tr id="BackupdrStarup4">
                <th style="width: 85%;padding:0px 5px;border-left: 1px solid #808080;"></th>
                <th id="BkpStartupOneTime" class="text-right" style="width: 15%;padding:0px 5px;font-weight:400;color: #305496;border-left: 1px solid #808080;border-top: 1px solid #808080;border-right: 1px solid #808080;"><br></th>
            </tr>
          <tr id="BackupdrStarup5">
          <th class="text-left" style="width: 85%;padding: 0px 0px 0px 15px;font-weight:400;color: #305496;border-left: 1px solid #808080;border-bottom: 1px solid #808080;">Courtesy Discount</th>
          <th id="backUpDrOneTimeDiscount" class="text-right" style="width: 15%;font-weight:400;padding:0px 5px;border: 1px solid #808080;color: red;"></th>
      </tr>
      <tr id="BackupdrStarup13">
      <th class="text-left" style="width: 85%;background-color: #d9d9d9;padding: 0px 5px;color: #000;border-left: 1px solid #808080;border-bottom: 1px solid #808080;"><b>Subtotal - Start Up Fees</b></th>
      <th class="text-right" style="width: 15%;padding:0px 5px;border-bottom: 1px solid #808080;border-top: 1px solid #808080;border-right: 1px solid #808080;color: #000;background-color: #d9d9d9;"><b id="backUpDrStartupSubtotal"></b></th>
  </tr>
          </thead>
          </table>

          <table id="BackupdrStarup6" style="margin-top: 5px;">
          <thead>
          <tr>
          <th style="text-align: left;padding: 0px 5px;border: 1px solid #000;background-color: #f2f2f2;color: #000;">
            <b>Backup DR One Time Fees</b>
          </th>
          </tr>
                <tr  id="BackupdrStarup12">
                 <th style="padding: 0px;">
                 <div id="backupDrOneTimeDescribe" class="text-left" style="padding: 5px 15px;
                 overflow-x: hidden;border-right: 1px solid #808080;color: #305496;font-weight:400;
                 overflow-y: auto;border-top: 1px solid #808080;border-left: 1px solid #808080;min-height: 50px;"></div>
                </th> 
                </tr>
            </thead>
        </table>
          <table id="BackupdrStarup7">
          <thead>
            <tr id="BackupdrStarup8">
                <th style="width: 85%;padding: 0px 5px;border-left: 1px solid #808080;"></th>
                <th id="TotalBackupDrOneTime" class="text-right" style="width: 15%;padding: 0px 5px;font-weight:400;color: #305496;border-left: 1px solid #808080;border-top: 1px solid #808080;border-right: 1px solid #808080;"></th>
            </tr>
          <tr id="BackupdrStarup9">
          <th class="text-left" style="width: 85%;padding: 0px 0px 0px 15px;font-weight:400;color: #305496;border-left: 1px solid #808080;border-bottom: 1px solid #808080;">Courtesy Discount of <span id="backUpDrOneTimeDiscntPercent"></span></th>
          <th id="BkpBackupDrOneTimeDiscount" class="text-right" style="width: 15%;font-weight:400;padding:0px 5px;border: 1px solid #808080;color: red;"></th>
      </tr>
      <tr>
      <th class="text-left" style="width: 85%;background-color: #d9d9d9;padding: 0px 5px;color: #000;border-left: 1px solid #808080;border-bottom: 1px solid #808080;"><b>Subtotal - Backup DR One Time Fees</b></th>
      <th class="text-right" style="width: 15%;background-color: #d9d9d9;padding: 0px 5px;border-top: 1px solid #808080;border-bottom: 1px solid #808080;border-right: 1px solid #808080;color: #000;"><b id="BkpBackupDrSubtotal"></b></th>
  </tr>
          </thead>
          </table>

          <table id="BackupdrStarup10">
          <tbody>
          <tr>
          <th class="text-left" style="padding:3px 5px;width: 85%;background-color: #808080;color: #fff;">TOTAL - ONE TIME Start-up Fees</th>
          <th id="BackupDrTotalOneTimeStartupFees" class="text-right" style="padding:3px 5px;width: 15%;background-color: #808080;color: #fff;"><br/></th>
          </tr>
          </tbody>
        </table>
        <table style="margin-top: 15px;" id="BackupdrMonthly1">
          <thead>
            <tr>
              <th colspan="12" style="text-align: left;background-color: #000;font-weight: 700;color: #fff;padding:3px 15px;">MONTHLY Backup Tool Fees</th>
            </tr>
            <tr>
              <th colspan="12" class="text-left"
                style="border-bottom: 1px solid #000;border-right: 1px solid #000;font-weight: 700;padding:3px 5px;border-left: 1px solid #000;background-color: #f2f2f2;color: #000;">
                Backup Tools</th></tr>
          </thead>
        </table>
        <table id="BackupdrMonthly2">
          <thead>
                <tr>
                 <th style="padding: 0px;">
                 <div id="BackupDrBackupToolsLists" class="text-left" style="padding: 5px 15px;
                 overflow-x: hidden;border-right: 1px solid #808080;color: #305496;font-weight:400;
                 overflow-y: auto; border-left: 1px solid #808080;min-height: 75px;"></div>
                </th> 
                </tr>
            </thead>
        </table>
          <table id="BackupdrMonthly3">
          <thead>
            <tr>
                <th style="width: 85%;padding:0px 5px;border-left: 1px solid #808080;"></th>
                <th id="BackupDrMonthlyFees" class="text-right" style="width: 15%;padding:0px 5px;font-weight:400;color: #305496;border-left: 1px solid #808080;border-top: 1px solid #808080;border-right: 1px solid #808080;"><br></th>
            </tr>
          </thead>
          </table>
      <table id="BackupdrMonthly4">
        <thead>
          <tr>
            <th colspan="12" style="padding: 0px;">
              <div class="text-left" style="padding: 5px 15px;border-top: 1px solid #000;
              overflow-x: hidden;border-right: 1px solid #000;color: #404040;
              overflow-y: auto; border-left: 1px solid #000;background-color: #fff;"><i>NOTE: Tool fees listed above are subject to change due to      a) Vendor pricing changes      b)  exchange rate fluctions
                 c)  No. of Users / Devices in use at <span id="BkpNoteClientCompanyName"></span>
              </i></div>
             </th> 
          </tr>
        </thead>
      </table>
      <table id="BackupdrMonthly5">
        <tr>
          <th style="padding:5px;border-left: 1px solid #000;border-right: 1px solid #000;border-top: 1px solid #000;"></th>
      </tr>
      </table>
      <table id="BackupdrMonthly6">
        <tr>
          <th id="backUpDrMonthlyDiscount" class="text-left" style="width: 85%;padding: 5px 0px 5px 15px;font-weight:400;color: #305496;border-bottom: 1px solid #808080;border-top: 1px solid #808080;border-left: 1px solid #808080;"><br /></th>
          <th id="backUpDrMonthlyDiscountVal" class="text-right" style="width: 15%;padding: 5px;font-weight:400;border-right: 1px solid #808080;border-bottom: 1px solid #808080;border-top: 1px solid #808080;color: red;"><br /></th>
      </tr>
      </table>
      <table id="BackupdrMonthly7">
        <tr>
          <th style="padding:5px;border-left: 1px solid #000;border-right: 1px solid #000;border-top: 1px solid #000;"></th>
      </tr>
      </table>
      <table  id="BackupdrMonthly8">
        <thead>
            <tr>
            <th class="text-left" style="border-bottom: 1px solid #000;border-top: 1px solid #000;border-left: 1px solid #000;padding:5px;width: 85%;background-color: #d9d9d9;color: #000;"><b>TOTAL - MONTHLY Backup Tool Fees</b></th>
            <th id="BackupDrTotalMonthlyFees" class="text-right" style="font-weight: 700;border: 1px solid #000;padding:5px;width: 15%;background-color: #d9d9d9;color: #000;"><br/></th>
            </tr>
        </thead>
      </table>
      <table style="margin-top: 10px;">
        <tbody>
          <tr>
            <th style="width: 65%;padding: 5px;text-align: left;background-color: #000;color: #fff;font-weight: 500;">
             Fee Summary </th>
            <th style="width: 20%;padding: 5px;text-align: right;background-color: #000;color: #fff;">One Time</th>
            <th id="backupDrOneTime" style="width: 15%;padding: 5px;text-align: right;background-color: #000;color: #fff;"></th>
          </tr>
          <tr>
            <th style="width: 65%;padding: 5px;text-align: left;background-color: #000;color: #fff;font-weight: 500;">
              </th>
            <th style="width: 20%;padding: 5px;text-align: right;background-color: #000;color: #fff;">Monthly</th>
            <th id="backupDrMonthly" style="width: 15%;padding: 5px;text-align: right;background-color: #000;color: #fff;"></th>
          </tr>
        </tbody>
      </table>
      <table id="showBkpDiscount">
      <tbody>
      <tr>
      <th colspan="12" style="font-weight: 400;font-size: 12px;padding: 5px 10px;text-align: left;background-color: #000;color: #fff;">
       <i>Includes <span id="BackupDrDiscountMonth"></span></i> </th>
      </tr>
      </tbody>
      </table>
        </div>`,
    },
    {
      "id": "5",
      "templateName": '6',
      "name": 'HW/SW HaaS/SaaS',
      "selectIcon": "",
      "sheetName": "HW",
      "componentName": `<div class="pricingsheet_container">
        <table>
          <thead>
            <tr>
              <th colspan="12" style="text-align: center;background-color: #000;color: #fff;">HW/SW HaaS/SaaS<span id="hwswClientName"><span></th>
            </tr>
          </thead>
          </table>
          <table>
            <thead>
              <tr>
                <th class="text-right" style="width: 15%;font-weight: 400;color: #fff;padding: 10px;background-color: #fff;border-left: 1px solid #ccc;">
               </th>
                <th style="width: 5%;padding: 10px;background-color: #fff;color: #cf4d36;border-left: 1px solid #ccc;"></th>
                <th class="text-right" style="width: 15%;font-weight: 400;padding: 10px;background-color: #fff;border-left: 1px solid #ccc;">
                </th>
                <th class="text-right" style="width: 5%;color:#305496;color:#cf4d36;font-weight: 400;padding: 10px;background-color: #fff;border-left: 1px solid #ccc;">
                </th>
                <th class="text-right" style="width: 15%;font-weight: 400;padding: 10px;background-color: #fff;border-left: 1px solid #ccc;">
                </th>
                <th class="text-right" style="width: 10%;font-weight: 400;padding:10px;background-color: #fff;border-left: 1px solid #ccc;">
                </th>
                <th class="text-right" style="width: 15%;font-weight: 400;padding: 10px;background-color: #fff;border-left: 1px solid #ccc;">
                </th>
                <th class="text-right" style="width: 10%;color:#305496;font-weight: 400;padding: 10px;background-color: #fff;border-left: 1px solid #ccc;">
                </th>
                <th class="text-center" style="width: 10%;padding: 10px;background-color: #fff;border-left: 1px solid #ccc;border-right: 1px solid #ccc;">
                </th>
              </tr>
            </thead>
            </table>
            <table>
              <thead>
                <tr>
                  <th colspan="12" style="text-align: left;background-color: #000;color: #fff;padding: 5px;"><span id="LeaseOrPurchase"></span> Detail:</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th colspan="12" id="leaseOrPurchaseDescription" style="min-height: 50px;height: 50px;border-left: 1px solid #000;border-right: 1px solid #000;color: #305496;font-weight: 400;text-align: left;">								
                  </th>
                </tr>
              </tbody>
              </table>
              <table id="HidePurchase">
                <tbody>
                  <tr>
                    <th colspan="4" style="border-left: 1px solid #000;font-weight: 400;padding: 0px 5px;background-color: #bfbfbf;color: #305496;">
                      <div style="width: 100%;display: flex;">
                      <div style="width:50%;text-align:right;float:left;">Last Month Up </div>
                      <div style="width:50%;text-align:left;float:right;position: relative;left: 15px;"><b>Y</b></div>
                      </div>
                      </th>
                    <th colspan="4" style="font-weight: 400;padding: 0px 5px;background-color: #bfbfbf;color: #305496;">
                      <div style="width: 100%;display: flex;">
                      <div style="width:50%;text-align:right;float:left;">1st & Last</div>
                      <div style="width:50%;text-align:left;position: relative;left: 15px;float:right;"><b id="HWSWfirstLastMnthPmt"></b></div>
                      </div>
                      </th>
                    <th colspan="4" style="border-right: 1px solid #000;font-weight: 400;padding: 0px 5px;background-color: #bfbfbf;color: #305496;">
                     <div style="width: 100%;display: flex;">
                     <div style="width:50%;text-align:right;float:left;">First Inv. Date:</div>
                     <div style="width:50%;text-align:left;position: relative;left: 15px;float:right;"></div>
                     </div>
                    </th>
                  </tr>
                  <tr>
                    <th colspan="4" style="border-left: 1px solid #000;font-weight: 400;padding: 0px 5px;background-color: #bfbfbf;color: #305496;">
                      <div style="width: 100%;display: flex;">
                      <div style="width:50%;text-align:right;float:left;">front ? :</div>
                      <div style="width:50%;text-align:left;position: relative;left: 15px;float:right;"></div>
                      </div>
                      </th>
                    <th colspan="4" style="font-weight: 400;padding: 0px 5px;background-color: #bfbfbf;color: #305496;">
                      <div style="width: 100%;display: flex;">
                      <div style="width:50%;text-align:right;float:left;">Mnth Pmt:</div>
                      <div style="width:50%;text-align:left;position: relative;left: 15px;float:right;"><b>+ HST</b></div>
                      </div>
                      </th>
                    <th colspan="4" style="border-right: 1px solid #000;font-weight: 400;padding: 0px 5px;background-color: #bfbfbf;color: #305496;">
                    <div style="width: 100%;display: flex;">
                    <div style="width:50%;text-align:right;float:left;"></div>
                    <div style="width:50%;text-align:left;position: relative;left: 15px;bottom: 10px;float:right;"><b id="HWSWfirstInvDate"></b></div>
                    </div>
                    </th>
                  </tr>
                  <tr>
                    <th colspan="4" style="border-left: 1px solid #000;font-weight: 400;padding: 2px 5px;background-color: #f2f2f2;color: #305496;">
                     <div style="width: 100%;display: flex;">
                     <div style="width:50%;text-align:right;float:left;">Lease Length: </div>
                     <div style="width:50%;text-align:left;position: relative;left: 15px;float:right;"><b><span id="HWSWleaseLen"></span> Months</b></div>
                     </div>
                     </th>
                    <th colspan="4" style="font-weight: 400;padding: 2px 5px;background-color: #f2f2f2;color: #305496;">
                     <div style="width: 100%;display: flex;">
                     <div style="width:50%;text-align:right;float:left;">Reg. Mnth</div>
                     <div style="width:50%;text-align:left;position: relative;left: 15px;float:right;"><b id="HWSWregMonthPmt"></b></div>
                     </div>
                     </th>
                    <th colspan="4" style="border-right: 1px solid #000;font-weight: 400;padding: 2px 5px;background-color: #f2f2f2;color: #305496;">
                      <div style="width: 100%;display: flex;">
                      <div style="width:50%;text-align:right;float:left;">Continuing for Next <b id="HWSWnextMonths"></b></div>
                      <div style="width:50%;text-align:left;position: relative;left: 15px;float:right;"></div>
                      </div>
                      </tr>
                  <tr>
                    <th colspan="4" style="border-left: 1px solid #000;font-weight: 400;padding: 0px 5px;background-color: #f2f2f2;color: #305496;">
                     <div style="width: 100%;display: flex;">
                     <div style="width:50%;text-align:right;float:left;">Duration : </div>
                     <div style="width:50%;text-align:left;position: relative;left: 15px;float:right;"><b><span id="HWSWduration"></span> Months</b></div>
                     </div>
                     </th>
                    <th colspan="4" style="font-weight: 400;padding: 0px 5px;background-color: #f2f2f2;color: #305496;">
                     <div style="width: 100%;display: flex;">
                     <div style="width:50%;text-align:right;float:left;">Pmt : </div>
                     <div style="width:50%;text-align:left;position: relative;left: 15px;float:right;"><b>+ HST</b></div>
                     </div>
                     </th>
                    <th colspan="4" style="border-right: 1px solid #000;font-weight: 400;padding: 0px 5px;background-color: #f2f2f2;color: #305496;">
                      <div style="width: 100%;display: flex;">
                      <div style="width:50%;text-align:right;float:left;">Mths. Last Inv. on: </div>
                      <div style="width:50%;text-align:left;position: relative;left: 15px;bottom: 10px;float:right;"><b id="HWSWlastInvDate"></b></div>
                      </div>
                      </tr>
                </tbody>
              </table>
              <table>
                <tbody>
                  <tr>
                    <th colspan="12" style="padding: 5px;text-align: left;background-color: #000;color: #fff;">Pricing Table</th>
                  </tr>
                </tbody>
              </table>
              <table>
                <thead>
                  <tr>
                    <th style="width: 5%;border-left: 1px solid #000;border-bottom: 1px solid #000;background-color: #d0cece;padding: 0px 5px;"><b>Qty</b></th>
                    <th style="width: 65%;text-align:left;background-color: #d0cece;border-bottom: 1px solid #000;padding: 0px 5px;"><b>Description</b></th>
                    <th style="width: 15%;text-align:right;background-color: #d0cece;border-bottom: 1px solid #000;padding: 0px 5px;"><b>Unit</b></th>
                    <th style="width: 15%;text-align:right;border-right: 1px solid #000;border-bottom: 1px solid #000;background-color: #d0cece;padding: 0px 5px;"><b>Extended</b></th>
                  </tr>
                </thead>
                <tbody id="HWSWTable">
                <tr id="HwSwRow0">
                  <th style="color: #305496;font-weight:500;width: 5%;border-left: 1px solid #000;border-bottom: 1px solid #000;padding: 0px 5px;"></th>
                  <th style="color: #305496;font-weight:500;text-align:left;width: 65%;border-left: 1px solid #000;border-bottom: 1px solid #000;padding: 0px 5px;"></th>
                  <th style="color: #305496;font-weight:500;text-align:right;width: 15%;border-left: 1px solid #000;border-bottom: 1px solid #000;padding: 0px 5px;"></th>
                  <th style="color: #305496;font-weight:500;text-align:right;width: 15%;border-right: 1px solid #000;border-left: 1px solid #000;border-bottom: 1px solid #000;padding: 0px 5px;"></th>
                  </tr>
              </tbody>
              </table>
              <table>
                <thead>
                  <tr>
                    <th class="text-right" style="width: 15%;font-weight: 400;color: #fff;padding: 3px;background-color: #fff;border-left: 1px solid #ccc;">
                   </th>
                    <th style="width: 5%;padding: 3px;background-color: #fff;color: #cf4d36;border-left: 1px solid #ccc;"></th>
                    <th class="text-right" style="width: 15%;font-weight: 400;padding: 3px;background-color: #fff;border-left: 1px solid #ccc;">
                    </th>
                    <th class="text-right" style="width: 5%;color:#305496;color:#cf4d36;font-weight: 400;padding: 3px;background-color: #fff;border-left: 1px solid #ccc;">
                    </th>
                    <th class="text-right" style="width: 15%;font-weight: 400;padding: 3px;background-color: #fff;border-left: 1px solid #ccc;">
                    </th>
                    <th class="text-right" style="width: 10%;font-weight: 400;padding:3px;background-color: #fff;border-left: 1px solid #ccc;">
                    </th>
                    <th class="text-right" style="width: 15%;font-weight: 400;padding: 3px;background-color: #fff;border-left: 1px solid #ccc;">
                    </th>
                    <th class="text-right" style="width: 10%;color:#305496;font-weight: 400;padding: 3px;background-color: #fff;border-left: 1px solid #ccc;">
                    </th>
                    <th class="text-center" style="width: 10%;padding: 3px;background-color: #fff;border-left: 1px solid #ccc;border-right: 1px solid #ccc;">
                    </th>
                  </tr>
                </thead>
                </table>
                <table>
                  <tbody>
                    <tr>
                      <th style="width: 50%;padding: 5px;text-align: left;background-color: #000;color: #fff;font-weight: 500;">
                       Fee Summary </th>
                      <th style="width: 35%;padding: 5px;text-align: right;background-color: #000;color: #fff;" id="HWSWFeeSummaryLP"></th>
                      <th style="width: 15%;padding: 5px;text-align: right;background-color: #000;color: #fff;" id="HWSWleaseDetail"></th>
                    </tr>
                    <tr>
                      <th style="width: 50%;padding: 5px;text-align: left;background-color: #000;color: #fff;font-weight: 500;">
                       </th>
                      <th style="width: 35%;padding: 5px;text-align: right;background-color: #000;color: #fff;" id="HWSWLeaseHst">HST</th>
                      <th style="width: 15%;padding: 5px;text-align: right;background-color: #000;color: #fff;"><u id="HWSWHst"></u></th>
                    </tr>
                    <tr>
                      <th style="width: 50%;padding: 5px;text-align: left;background-color: #000;color: #fff;font-weight: 500;">
                       </th>
                      <th style="width: 35%;padding: 5px;text-align: right;background-color: #000;color: #fff;" id="HWSWLeaseTotal">Total</th>
                      <th style="width: 15%;padding: 5px;text-align: right;background-color: #000;color: #fff;" id="HWSWTotal"></th>
                    </tr>
                    </tbody>
                    </table>
          </div>`,
    },
    {
      "id": "6",
      "templateName": '7',
      "name": 'Project',
      "selectIcon": "",
      "sheetName": "PJT",
      "componentName": `<div class="project_container" style="  position: relative;
        overflow: auto;">
          <table>
            <thead>
              <tr>
                <th colspan="12" style="text-align: center;padding: 5px;background-color: #000;color: #fff;">Project<span id="projectClientName"><span></th>
              </tr>
            </thead>
            </table>
            <table id="projectActivity1">
            <thead>
              <tr>
                <th
                  style="width:75%;padding:5px;border-left: 1px solid #000;text-align: left;background-color: #f2f2f2;color: #000;">
                  Project Activity Description and Fees</th>
                <th 
                  style="width:10%;padding:5px;border-left: 1px solid #000;text-align: right;background-color: #f2f2f2;color: #000;">
                  Hours</th>
                <th
                  style="width:15%;padding:5px;border-left: 1px solid #000;border-right: 1px solid #000;text-align: right;background-color: #f2f2f2;color: #000;">
                  Total</th>
              </tr>
            </thead>
            <tbody id="projectActivityTable">
              <tr  id="projectActivityJSON0">
                <th style="width:75%;text-align: left;border-bottom: 1px solid #000;border-left: 1px solid #000;border-top: 1px solid #000;color: #407fc9;font-size: 12px;"></th>
                <th style="width:10%;border-bottom: 1px solid #000;border-left: 1px solid #000;border-top: 1px solid #000;color: #407fc9;text-align:right;font-size: 12px;"></th>
                <th style="padding: 10px 5px;width:15%;border-bottom: 1px solid #000;border-right: 1px solid #000;border-left: 1px solid #000;border-top: 1px solid #000;color: #407fc9;font-size: 12px;text-align:right;"></th>
              </tr>
            </tbody>
            </table>
            <table id="projectActivity2">
            <tbody id="projectActivityTable1">
              <tr  id="projectActivityJSON1">
                <th style="width:85%;text-align:left;border-bottom: 1px solid #000;border-left: 1px solid #000;border-top: 1px solid #000;color: #407fc9;font-size: 12px;"></th>
                <th style="width:15%;padding: 10px 5px;border-bottom: 1px solid #000;border-right: 1px solid #000;border-left: 1px solid #000;border-top: 1px solid #000;font-size: 12px;color: #407fc9;text-align:right;">
                </th>
                </tr>
            </tbody>
            <tbody>
            <tr id="projectDiscount">
                <th
                  style="width:85%;padding: 0px 10px;border-left: 1px solid #000;text-align: left;background-color: #fff;color: #407fc9;">
                  Courtesy Discount</th>
                <th id="courtesyDiscount"
                  style="width:15%;padding: 0px 5px;border-right: 1px solid #000;text-align: right;background-color: #fff;color: red;">
                  </th>
              </tr>
              <tr>
                <th
                  style="width:85%;padding:3px;border-bottom: 1px solid #000;border-top: 1px solid #000;border-left: 1px solid #000;text-align: left;background-color: #f2f2f2;color: #000;">
                  TOTAL - Project Activity Description and Fees - Hourly</th>
                <th id="TotalProjectActivity"
                  style="width:15%;padding:3px;border-bottom: 1px solid #000;border-top: 1px solid #000;border-right: 1px solid #000;text-align: right;background-color: #f2f2f2;color: #407fc9;">
                  </th>
              </tr>
              </tbody>
              </table>
              <table>
              <tbody>
              <tr style="width: 100%;">
                <th style="width: 10%;" colspan="2"></th>
                <th style="width: 10%;"></th>
                <th style="width: 10%;"></th>
                <th colspan="2" style="width: 30%;"></th>
                <th style="width: 10%;"></th>
                <th style="width: 10%;"></th>
                <th style="width: 10%;"></th>
                <th style="width: 10%;"></th>
              </tr>
              </tbody>
              </table>
              <table id="projectHSLW1">
              <tbody>
              <tr>
                <th colspan="12" style="padding:5px;text-align:left;background-color: #000;color: #fff;">
                  Hardware/Software/Licences/Warranties</th>
              </tr>
            </tbody>
            </table>
            <table id="projectHSLW2">
            <tbody>
              <tr style="width: 100%;">
                <th
                  style="width: 5%;border-bottom: 1px solid #000;padding:5px;border-left: 1px solid #000;background-color: #f2f2f2;">Qty
                </th>
                <th
                  style="width: 70%;text-align: left;padding:5px;border-bottom: 1px solid #000;background-color: #f2f2f2;">
                  Description</th>
                <th
                  style="width: 10%;text-align:right;padding:5px;border-bottom: 1px solid #000;background-color: #f2f2f2;">
                  Unit Price</th>
                <th
                  style="width: 15%;border-bottom: 1px solid #000;border-right: 1px solid #000;padding:5px;background-color: #f2f2f2;">
                  Extended</th>
              </tr>
              <tbody id="tableToModify">
              <tr id="projectJSON0" style="width: 100%;">
                <td
                  style="width: 5%;text-align: center;font-size: 12px;border-bottom: 1px solid #000;border-left: 1px solid #000;padding:5px;background-color: #fff;color: #407fc9;">
               <br /> </td>
                <td
                  style="width: 70%;font-size: 12px;border-bottom: 1px solid #000;border-left: 1px solid #000;text-align: left;padding:5px;background-color: #fff;color: #407fc9;">
                  <br />   </td>
                <td
                  style="width: 10%;text-align: right;font-size: 12px;border-bottom: 1px solid #000;border-left: 1px solid #000;padding:5px;background-color: #fff;color: #407fc9;">
                  <br />   </td>
                <td
                  style="width: 15%;text-align: right;font-size: 12px;border-bottom: 1px solid #000;border-right: 1px solid #000;border-left: 1px solid #000;padding:5px;background-color: #fff;color: #407fc9;">
                  <br />  </td>
              </tr>
              </tbody>
              </table>
              <table>
              <tbody id="projectHSLW3">
              <tr>
                <th colspan="10"
                  style="padding:5px;border-bottom: 1px solid #000;border-top: 1px solid #000;border-left: 1px solid #000;text-align: left;background-color: #f2f2f2;color: #000;">
                  TOTAL Hardware/Software/Licences/Warranties</th>
                <th id="totalHslw" colspan="2"
                  style="background-color: #f2f2f2;padding:5px;border-bottom: 1px solid #000;border-top: 1px solid #000;border-right: 1px solid #000;text-align: right;color: #000;">
                  </th>
              </tr>
              </tbody>
              <tr style="width: 100%;">
                <th style="width: 10%;padding: 3px;" colspan="2"></th>
                <th style="width: 10%;padding: 3px;"></th>
                <th style="width: 10%;padding: 3px;"></th>
                <th colspan="2" style="width: 30%;padding: 3px;"></th>
                <th style="width: 10%;padding: 3px;"></th>
                <th style="width: 10%;padding: 3px;"></th>
                <th style="width: 10%;padding: 3px;"></th>
                <th style="width: 10%;padding: 3px;"></th>
              </tr>
              <tr id="projFeeSummaryActivity">
                <th colspan="6" style="padding: 5px;text-align: left;background-color: #000;color: #fff;font-weight: 500;">Fee Sumary</th>
                <th colspan="4" style="padding: 5px;text-align: right;background-color: #000;color: #fff;">Project Fees</th>
                <th id="feeTotalProjectActivity" colspan="2" style="padding: 5px;text-align: right;background-color: #000;color: #fff;"></th>
              </tr>
              <tr id="projFeeSummaryHSLW">
                <th colspan="10" style="padding: 5px;text-align: right;background-color: #000;color: #fff;">One Time Hardware/Software/Licences/Warranties</th>
                <th colspan="2" style="padding: 5px;text-align: right;background-color: #000;color: #fff;"  id="feeTotalHslw"></th>
              </tr>
            </>
          </table>
        </div>`,
    }]
  },
  {
    'id': 'ProposalCreate',
    'templates': [
      {
        'id': "0",
        "name": 'Dashboard',
        "sheetId": "DASHBOARD",
        "componentName": CoverScreenComponent
      }, {
        'id': "1",
        "name": 'MSP Pricing Sheet',
        "sheetId": "MSP",
        "componentName": MspPricingSheetComponent
      }, {
        'id': "2",
        "name": 'CYBER Pricing Sheet',
        "sheetId": "CYB",
        "componentName": CyberPricingSheetComponent
      }, {
        'id': "3",
        "name": 'CLOUD Pricing Sheet',
        "sheetId": "CLD",
        "componentName": CloudPricingSheetComponent
      }, {
        'id': "4",
        "name": 'BACKUP/DR Pricing Sheet',
        "sheetId": "BKP",
        "componentName": BackupdrPricingSheetComponent
      }, {
        'id': "5",
        "name": 'HW/SW HaaS/SaaS',
        "sheetId": "HW",
        "componentName": HardwareSoftwareSheetComponent
      }, {
        'id': "6",
        "name": 'Project',
        "sheetId": "PJT",
        "componentName": ProjectComponent
      }
    ]
  },
  {
    'id': 'PriceList',
    'templates': [{
      'id': "0",
      "name": 'Price List',
      "componentName": PricelistMasterPage
    },
    {
      'id': "1",
      "name": 'MSA',
      "componentName": MsaPage
    },
    {
      'id': "2",
      "name": 'SOW',
      "componentName": SowPage
    },
    {
      'id': "3",
      "name": 'Sow List',
      "componentName": SowListPage
    }]
  }];
  projectJSON: any;
  tabName: any = 'ProposalCreate';
  msaData: any;
  serviceData: any;
  screenData: any;
  constructor(public http: HttpClient, public dataService: DataServiceProvider) {
    var dataprojectJSON = localStorage.getItem('projectJSON')
    this.projectJSON = JSON.parse(dataprojectJSON)
    this.screenData = JSON.stringify(this.tabTemplates[0].templates)
  }
  ClearData() {
    localStorage.clear();
    this.tabTemplates[0].templates = JSON.parse(this.screenData);
  }
  proposalCalculation() {
    // var len: any;
    // this.ServiceScreen = JSON.parse(this.serviceData);
    // this.ServiceScreen.forEach(element => {
    //   if (element.IsChecked == true) {
    //     if (len != undefined) {
    //       element.pageNo = len + 1;
    //       len = element.pageNo;
    //     } else {
    //       len = 1;
    //       element.pageNo = len;
    //     }
    //   }
    // });
    // this.dataService.TableContent = this.ServiceScreen;
    // localStorage.setItem('TableContent', JSON.stringify(this.dataService.TableContent));
  }
}



// WEBPACK FOOTER //
// ./src/providers/component-service/component-service.ts